import type { FC } from "react";

import { AlertBanner } from "@jti/core-components/components/AlertBanner";
import { useTranslations } from "@jti/ui";

type TrialBlockingCheckoutMessageBoxProps = { isVisible: boolean };

export const TrialBlockingCheckoutMessageBox: FC<TrialBlockingCheckoutMessageBoxProps> = ({ isVisible }) => {
  const { __ } = useTranslations();

  return isVisible ? <AlertBanner tone="warning" description={__("libs.ui.notification.limit.trial")} /> : null;
};
